import { API_URL } from "config";
import Http from "util/https";
import Notify from "config/notify";
import { OrderSupplierUpdateParams } from "../types";

/**
 * 受注を出荷するAPI
 * @param params 注文情報
 */
export default async function updateOrderSupplierApi(params: OrderSupplierUpdateParams) {
  console.log("updateOrderSupplier:", params.shipment_infos);

  const http = Http.default.alterAuth({ useToken: true });
  const url = `${API_URL}/order/shipping/update`;
  const res = await http.post<null>(url, params);
  // await new Promise<void>((resolve) => {setTimeout(resolve, 1500)});

  // const res = {status: 200};
  // if (res.status === 200) {
  //   Notify.setNotification({
  //     show: true,
  //     title: "更新が完了しました",
  //     confirmLabel: "OK",
  //     actionsPosition: "end",
  //   });
  // }
}
